import { use } from "react";
import { RowSelectionContext } from "./RowSelectionContext";

export function useRowSelection() {
  const rowSelectionContext = use(RowSelectionContext);

  if (!rowSelectionContext) {
    throw new Error("This Hook must be used under RowSelectionProvider!");
  }

  return rowSelectionContext;
}
